




















import { Component, Vue } from "vue-property-decorator";
import { mapMutations, mapState } from "vuex";
import { Message } from "@/interfaces/alert";

@Component({
  computed: {
    ...mapState("alert", ["message"])
  },
  methods: {
    ...mapMutations("alert", ["clearMessage"])
  }
})
export default class Alert extends Vue {
  message!: Message;
  clearMessage!: () => void;

  get toggle(): boolean {
    return this.message.color !== "";
  }

  set toggle(value: boolean) {
    this.clearMessage();
  }
}
